// import React, { useState, useEffect } from "react";
// // import * as XLSX from "xlsx";
// import {
//     Card,
//     CardHeader,
//     CardBody,
//     Container,
//     Row,
//     Col,
//     FormGroup,
//     Input,
//     UncontrolledDropdown,
//     DropdownToggle,
//     DropdownMenu,
//     DropdownItem,
//     Label,
//     Button, Modal, ModalHeader, ModalBody, ModalFooter
// } from "reactstrap";
// import moment from "moment";
// import { Link, useHistory } from "react-router-dom";
// import { CSVLink } from "react-csv";
// // APi
// import queryString from "query-string";
// import Dataservices from "../../services/requestApi";

// // core components
// import Header from "components/Headers/Header";
// import SearchViaDate from "components/Filter/SearchViaDate";
// import { Table } from "antd";
// import { PlusOutlined } from "@ant-design/icons";

// function AllCreateOrder() {
//     const [ready, setReady] = useState(false);
//     const [search, setSearch] = useState("");
//     const [fromDate, setFromDate] = useState(undefined);
//     const [toDate, setToDate] = useState(undefined);
//     const [AllOrder, setAllOrder] = useState([]);
//     const [pagination, setPagination] = useState();
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageSize, setPageSize] = useState(10);
//     const [total, setTotal] = useState();
//     const [password, setPassword] = useState(""); // State for password input
//     const [isPasswordVerified, setIsPasswordVerified] = useState(false); // State for password verification
//     const [isModalOpen, setIsModalOpen] = useState(false);

//     const toggleModal = () => {
//         setIsModalOpen(!isModalOpen);
//     }

//     const handlePasswordChange = (e) => {
//         setPassword(e.target.value);
//     };

//     const verifyPassword = () => {
//         // Assuming you have a function to verify the password
//         if (password === "Keshav@1996") { // Replace with your real check logic
//             setIsPasswordVerified(true);
//             setIsModalOpen(false);  // Close the modal upon successful verification
//         } else {
//             alert("Incorrect password");
//         }
//     };

//     const history = useHistory();

//     useEffect(() => {
//         GetAllOrder(fromDate, toDate, currentPage, pageSize, search);
//         return () => {
//             GetAllOrder(fromDate, toDate, currentPage, pageSize, search);
//         };
//     }, [search]);
//     // GetAllOrder
//     const GetAllOrder = async (from, end, currentPage, pageSize, search) => {
//         try {
//             setReady(true);
//             const res = await Dataservices.getManualOrder(from, end, currentPage, pageSize, search);
//             setAllOrder(res.data?.data);
//             setTotal(res.data?.total);
//             setReady(false);
//         } catch (e) {
//             console.log(e);
//         }
//     };

//     const updateProudctOrder = async (id, data) => {
//         try {
//             await Dataservices.updateProudctOrder(id, queryString.stringify(data));
//             GetAllOrder(fromDate, toDate, currentPage, pageSize, search);
//         } catch (e) {
//             console.log(e);
//         }
//     };

//     const deleteOrder = async (id) => {
//         // try {
//         //   await Dataservices.deleteOrder(id);
//         //   GetAllOrder();
//         // } catch (e) {
//         //   console.log(e);
//         // }
//     };
//     // const searchFilter = AllOrder.filter((data) => {
//     //   const name = data?.distributor?.name;
//     //   const phone = data?.distributor?.phone;
//     //   const FilterName = name.toLowerCase().includes(search.toLowerCase());
//     //   const FilterPhone = phone.includes(search.toLowerCase());
//     //   if (FilterName) {
//     //     return FilterName;
//     //   }
//     //   if (FilterPhone) {
//     //     return FilterPhone;
//     //   }
//     // });
//     const SearchDate = async () => {
//         if (fromDate && toDate) {
//             GetAllOrder(fromDate, toDate, currentPage, pageSize, search);
//         }
//     };

//     const csvData = [
//         ["Sr No.", "Name", "Phone", "Created on"],
//         ...AllOrder?.map((item, idx) => [
//             idx + 1,
//             item?.distributor?.name,
//             item?.distributor?.phone,
//             moment(item?.created_at?.split("T")[0]).format("ll"),
//         ]),
//     ];
//     function InvoiceGenerate(id) {
//         const order = AllOrder;
//         const CurrentOrder = order.find((item) => item._id === id);
//         history.push({ pathname: "/admin/invoice", state: CurrentOrder });
//     }
//     const columns = [
//         {
//             title: "Name",
//             dataIndex: "distributor",
//             key: "name",
//             render: (item) => item.name,
//         },
//         {
//             title: "Phone",
//             dataIndex: "distributor",
//             key: "phone",
//             render: (item) => item.phone,
//         },
//         {
//             title: "Created on",
//             dataIndex: "created_at",
//             key: "created_at",
//             render: (date) => moment(date?.split("T")[0]).format("ll"),
//         },
//         {
//             title: "Status",
//             dataIndex: "order_id",
//             key: "status",
//             render: (id, item) => (
//                 <FormGroup className="w-75 mb-0">
//                     <Input
//                         id="exampleSelect"
//                         name="select"
//                         type="select"
//                         onChange={(e) => {
//                             updateProudctOrder(item._id, {
//                                 status: e.target.value,
//                             });
//                         }}
//                         defaultValue={item.status}
//                     >
//                         <option value="">Update Status</option>
//                         <option value="In Process">In Process</option>
//                         <option value="Order Dispatched">Order Dispatched</option>
//                         <option value="Out for Delivery">Out for Delivery</option>
//                         <option value="Order Delivered">Order Delivered</option>
//                         <option value="Cancelled">Cancelled</option>
//                     </Input>
//                 </FormGroup>
//             ),
//         },

//         {
//             title: "Action",
//             dataIndex: "_id",
//             key: "_id",
//             render: (id, item) => (
//                 <Button
//                     onClick={() => InvoiceGenerate(id)}
//                     size="sm"
//                     color="dark"
//                     outline
//                     to={`orders-transaction/${item?._id}`}
//                     tag={Link}
//                 >
//                     <i className="ni ni-money-coins text-dark mr-2" />
//                     View Transactions
//                 </Button>
//             ),
//         },
//         {
//             title: "Invoice",
//             dataIndex: "_id",
//             key: "_id",
//             render: (id) => (
//                 <>
//                     <Button
//                         onClick={() => InvoiceGenerate(id)}
//                         size="sm"
//                         color="dark"
//                         outline
//                     >
//                         <span className="ni ni-active-40"></span>
//                     </Button>
//                 </>
//             ),
//         },
//     ];
//     function ExportExcel() {
//         // const wb = XLSX.utils.book_new();
//         // const ws = XLSX.utils.json_to_sheet(csvData);
//         // XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
//         //
//         // // Use XLSX.writeFile to trigger the download
//         // XLSX.writeFile(wb, "Allorder.xlsx");
//     }
//     const handleTableChange = (page, pageSize) => {
//         setCurrentPage(page);
//         setPageSize(pageSize);
//         GetAllOrder(fromDate, toDate, page, pageSize, search);
//     };

//     return (
//         <>
//             <Header show={false} />
//             <Container className="mt--7" fluid>
//                 <Row>
//                     <Col className="order-xl-1" xl="12">
//                         <Card className="shadow mt-4">
//                             <CardHeader className="bg-white border-0">
//                                 <Row className="align-items-center">
//                                     <Col>
//                                         <FormGroup className="mb-0">
//                                             <Label for="toDate" className="d-block">
//                                                 &nbsp;
//                                             </Label>
//                                             <Input
//                                                 id="title"
//                                                 placeholder="Search by Phone / Name"
//                                                 type="text"
//                                                 value={search}
//                                                 onChange={(e) => setSearch(e.target.value)}
//                                             />
//                                         </FormGroup>
//                                     </Col>
//                                     <SearchViaDate
//                                         fromDate={fromDate}
//                                         setFromDate={setFromDate}
//                                         toDate={toDate}
//                                         setToDate={setToDate}
//                                         action={SearchDate}
//                                     />
//                                     <Col md="3">
//                                         <Button className="mt-2" color="primary" onClick={toggleModal}>
//                                             Verify Password
//                                         </Button>
//                                     </Col>
//                                     <Button
//                                         color="primary"
//                                         size="sm"
//                                         className="float-right"
//                                         to="/admin/create-order"
//                                         tag={Link}
//                                         disabled={!isPasswordVerified} // Disable until password verified
//                                     >
//                                         <PlusOutlined /> Add Order
//                                     </Button>
//                                 </Row>
//                             </CardHeader>
//                             <CardBody>
//                                 <CSVLink
//                                     className="btn btn-outline-dark btn-sm"
//                                     filename="order.csv"
//                                     data={csvData}
//                                 >
//                                     Export CSV
//                                 </CSVLink>
//                                 <Button onClick={ExportExcel} outline size="sm" color="dark">
//                                     Export Excel
//                                 </Button>
//                                 <Table
//                                     id="AllOrder"
//                                     columns={columns}
//                                     loading={ready}
//                                     dataSource={AllOrder}
//                                     pagination={{
//                                         current: currentPage,
//                                         pageSize: pageSize,
//                                         total: total,
//                                         showSizeChanger: true,
//                                         onChange: (page, pageSize) => {
//                                             handleTableChange(page, pageSize)
//                                         }
//                                     }}
//                                 />
//                             </CardBody>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>


//             <Modal isOpen={isModalOpen} toggle={toggleModal}>
//                 <ModalHeader toggle={toggleModal}>Verify Password</ModalHeader>
//                 <ModalBody>
//                     <FormGroup>
//                         <Input
//                             type="password"
//                             placeholder="Enter password"
//                             value={password}
//                             onChange={handlePasswordChange}
//                             className="form-control-alternative"
//                         />
//                     </FormGroup>
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="primary" onClick={verifyPassword}>
//                         Verify
//                     </Button>
//                     <Button color="secondary" onClick={toggleModal}>
//                         Cancel
//                     </Button>
//                 </ModalFooter>
//             </Modal>

//         </>
//     );
// }

// export default AllCreateOrder;
























// import React, { useState, useEffect } from "react";
// import {
//     Card,
//     CardHeader,
//     CardBody,
//     Container,
//     Row,
//     Col,
//     FormGroup,
//     Input,
//     Label,
//     Button,
//     Modal,
//     ModalHeader,
//     ModalBody,
//     ModalFooter
// } from "reactstrap";
// import moment from "moment";
// import { Link, useHistory } from "react-router-dom";
// import { CSVLink } from "react-csv";
// import queryString from "query-string";
// import Dataservices from "../../services/requestApi";
// import Header from "components/Headers/Header";
// import SearchViaDate from "components/Filter/SearchViaDate";
// import { Table } from "antd";
// import { PlusOutlined } from "@ant-design/icons";

// function AllCreateOrder() {
//     const [ready, setReady] = useState(false);
//     const [search, setSearch] = useState("");
//     const [fromDate, setFromDate] = useState(undefined);
//     const [toDate, setToDate] = useState(undefined);
//     const [AllOrder, setAllOrder] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageSize, setPageSize] = useState(10);
//     const [total, setTotal] = useState();
//     const [totalSales, setTotalSales] = useState({ withTax: 0, withoutTax: 0 });
//     const [hasSearched, setHasSearched] = useState(false);
//     const [password, setPassword] = useState("");
//     const [isPasswordVerified, setIsPasswordVerified] = useState(false);
//     const [isModalOpen, setIsModalOpen] = useState(false);

//     const toggleModal = () => {
//         setIsModalOpen(!isModalOpen);
//     };

//     const handlePasswordChange = (e) => {
//         setPassword(e.target.value);
//     };

//     const verifyPassword = () => {
//         if (password === "Keshav@1996") {
//             setIsPasswordVerified(true);
//             setIsModalOpen(false);
//         } else {
//             alert("Incorrect password");
//         }
//     };

//     const history = useHistory();

//     // ✅ By default data nahi aayega - sirf search change hone pe aur hasSearched true ho tab
//     useEffect(() => {
//         if (search === "" && hasSearched) {
//             GetAllOrder(fromDate, toDate, currentPage, pageSize, "");
//         }
//     }, [search]);

//     const GetAllOrder = async (from, end, page, size, searchVal) => {
//         try {
//             setReady(true);
//             const res = await Dataservices.getManualOrder(from, end, page, size, searchVal);
//             setAllOrder(res.data?.data);
//             setTotal(res.data?.total);
//             // ✅ Summary set karo
//             setTotalSales({
//                 withTax: res.data?.summary?.totalWithTax || 0,
//                 withoutTax: res.data?.summary?.totalWithoutTax || 0,
//             });
//             setReady(false);
//         } catch (e) {
//             console.log(e);
//             setReady(false);
//         }
//     };

//     const updateProudctOrder = async (id, data) => {
//         try {
//             await Dataservices.updateProudctOrder(id, queryString.stringify(data));
//             GetAllOrder(fromDate, toDate, currentPage, pageSize, search);
//         } catch (e) {
//             console.log(e);
//         }
//     };

//     const deleteOrder = async (id) => {};

//     // ✅ Date search press hone pe hi data aayega
//     const SearchDate = async () => {
//         if (fromDate && toDate) {
//             setHasSearched(true);
//             setCurrentPage(1);
//             GetAllOrder(fromDate, toDate, 1, pageSize, search);
//         }
//     };

//     const csvData = [
//         ["Sr No.", "Name", "Phone", "Created on"],
//         ...AllOrder?.map((item, idx) => [
//             idx + 1,
//             item?.distributor?.name,
//             item?.distributor?.phone,
//             moment(item?.created_at?.split("T")[0]).format("ll"),
//         ]),
//     ];

//     function InvoiceGenerate(id) {
//         const order = AllOrder;
//         const CurrentOrder = order.find((item) => item._id === id);
//         history.push({ pathname: "/admin/invoice", state: CurrentOrder });
//     }

//     function ExportExcel() {}

//     const handleTableChange = (page, size) => {
//         setCurrentPage(page);
//         setPageSize(size);
//         GetAllOrder(fromDate, toDate, page, size, search);
//     };

//     const columns = [
//         {
//             title: "Name",
//             dataIndex: "distributor",
//             key: "name",
//             render: (item) => item?.name,
//         },
//         {
//             title: "Phone",
//             dataIndex: "distributor",
//             key: "phone",
//             render: (item) => item?.phone,
//         },
//         {
//             title: "Created on",
//             dataIndex: "created_at",
//             key: "created_at",
//             render: (date) => moment(date?.split("T")[0]).format("ll"),
//         },
//         {
//             title: "Status",
//             dataIndex: "order_id",
//             key: "status",
//             render: (id, item) => (
//                 <FormGroup className="w-75 mb-0">
//                     <Input
//                         id="exampleSelect"
//                         name="select"
//                         type="select"
//                         onChange={(e) => {
//                             updateProudctOrder(item._id, { status: e.target.value });
//                         }}
//                         defaultValue={item.status}
//                     >
//                         <option value="">Update Status</option>
//                         <option value="In Process">In Process</option>
//                         <option value="Order Dispatched">Order Dispatched</option>
//                         <option value="Out for Delivery">Out for Delivery</option>
//                         <option value="Order Delivered">Order Delivered</option>
//                         <option value="Cancelled">Cancelled</option>
//                     </Input>
//                 </FormGroup>
//             ),
//         },
//         {
//             title: "Action",
//             dataIndex: "_id",
//             key: "_id",
//             render: (id, item) => (
//                 <Button
//                     onClick={() => InvoiceGenerate(id)}
//                     size="sm"
//                     color="dark"
//                     outline
//                     to={`orders-transaction/${item?._id}`}
//                     tag={Link}
//                 >
//                     <i className="ni ni-money-coins text-dark mr-2" />
//                     View Transactions
//                 </Button>
//             ),
//         },
//         {
//             title: "Invoice",
//             dataIndex: "_id",
//             key: "_id",
//             render: (id) => (
//                 <Button
//                     onClick={() => InvoiceGenerate(id)}
//                     size="sm"
//                     color="dark"
//                     outline
//                 >
//                     <span className="ni ni-active-40"></span>
//                 </Button>
//             ),
//         },
//         {
//             title: "Tax Sales",
//             dataIndex: "total_amount",
//             key: "total_amount",
//             render: (amount) => `₹ ${Math.round(amount || 0)}`,
//         },
//         {
//             title: "Without Tax Sales",
//             dataIndex: "amount",
//             key: "amount",
//             render: (amount) => `₹ ${Math.round(amount || 0)}`,
//         },
//     ];

//     return (
//         <>
//             <Header show={false} />
//             <Container className="mt--7" fluid>
//                 <Row>
//                     <Col className="order-xl-1" xl="12">

//                         {/* ✅ Summary Cards - sirf search ke baad */}
//                         {hasSearched && (totalSales.withTax !== 0 || totalSales.withoutTax !== 0) && (
//                             <div className="mb-4 mt-4 d-flex" style={{ gap: "20px" }}>
//                                 <div
//                                     style={{
//                                         background: "#fff",
//                                         borderRadius: "12px",
//                                         padding: "18px 32px",
//                                         boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
//                                         borderLeft: "5px solid #2dce89",
//                                         minWidth: "220px",
//                                     }}
//                                 >
//                                     <p style={{ margin: 0, fontSize: "13px", color: "#888", fontWeight: 500 }}>
//                                         Sales With Tax
//                                     </p>
//                                     <h3 style={{ margin: 0, fontSize: "26px", fontWeight: 700, color: "#2dce89" }}>
//                                         ₹{Math.round(totalSales.withTax).toLocaleString("en-IN")}
//                                     </h3>
//                                 </div>

//                                 <div
//                                     style={{
//                                         background: "#fff",
//                                         borderRadius: "12px",
//                                         padding: "18px 32px",
//                                         boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
//                                         borderLeft: "5px solid #fb6340",
//                                         minWidth: "220px",
//                                     }}
//                                 >
//                                     <p style={{ margin: 0, fontSize: "13px", color: "#888", fontWeight: 500 }}>
//                                         Sales Without Tax
//                                     </p>
//                                     <h3 style={{ margin: 0, fontSize: "26px", fontWeight: 700, color: "#fb6340" }}>
//                                         ₹{Math.round(totalSales.withoutTax).toLocaleString("en-IN")}
//                                     </h3>
//                                 </div>
//                             </div>
//                         )}

//                         <Card className="shadow mt-2">
//                             <CardHeader className="bg-white border-0">
//                                 <Row className="align-items-center">
//                                     <Col>
//                                         <FormGroup className="mb-0">
//                                             <Label for="toDate" className="d-block">
//                                                 &nbsp;
//                                             </Label>
//                                             <Input
//                                                 id="title"
//                                                 placeholder="Search by Phone / Name"
//                                                 type="text"
//                                                 value={search}
//                                                 onChange={(e) => setSearch(e.target.value)}
//                                             />
//                                         </FormGroup>
//                                     </Col>
//                                     <SearchViaDate
//                                         fromDate={fromDate}
//                                         setFromDate={setFromDate}
//                                         toDate={toDate}
//                                         setToDate={setToDate}
//                                         action={SearchDate}
//                                     />
//                                     <Col md="3">
//                                         <Button className="mt-2" color="primary" onClick={toggleModal}>
//                                             Verify Password
//                                         </Button>
//                                     </Col>
//                                     <Button
//                                         color="primary"
//                                         size="sm"
//                                         className="float-right"
//                                         to="/admin/create-order"
//                                         tag={Link}
//                                         disabled={!isPasswordVerified}
//                                     >
//                                         <PlusOutlined /> Add Order
//                                     </Button>
//                                 </Row>
//                             </CardHeader>
//                             <CardBody>
//                                 <CSVLink
//                                     className="btn btn-outline-dark btn-sm"
//                                     filename="order.csv"
//                                     data={csvData}
//                                 >
//                                     Export CSV
//                                 </CSVLink>
//                                 <Button onClick={ExportExcel} outline size="sm" color="dark">
//                                     Export Excel
//                                 </Button>

//                                 {/* ✅ Sirf search ke baad table dikhega */}
//                                 {!hasSearched ? (
//                                     <div
//                                         className="text-center py-5"
//                                         style={{ color: "#aaa", fontSize: "15px" }}
//                                     >
//                                         <i
//                                             className="ni ni-calendar-grid-58 mb-3"
//                                             style={{ fontSize: "40px", display: "block" }}
//                                         />
//                                         Please select a date range and click <strong>Search</strong> to view orders.
//                                     </div>
//                                 ) : (
//                                     <Table
//                                         id="AllOrder"
//                                         columns={columns}
//                                         loading={ready}
//                                         dataSource={AllOrder}
//                                         pagination={{
//                                             current: currentPage,
//                                             pageSize: pageSize,
//                                             total: total,
//                                             showSizeChanger: true,
//                                             onChange: (page, size) => {
//                                                 handleTableChange(page, size);
//                                             },
//                                         }}
//                                     />
//                                 )}
//                             </CardBody>
//                         </Card>
//                     </Col>
//                 </Row>
//             </Container>

//             <Modal isOpen={isModalOpen} toggle={toggleModal}>
//                 <ModalHeader toggle={toggleModal}>Verify Password</ModalHeader>
//                 <ModalBody>
//                     <FormGroup>
//                         <Input
//                             type="password"
//                             placeholder="Enter password"
//                             value={password}
//                             onChange={handlePasswordChange}
//                             className="form-control-alternative"
//                         />
//                     </FormGroup>
//                 </ModalBody>
//                 <ModalFooter>
//                     <Button color="primary" onClick={verifyPassword}>
//                         Verify
//                     </Button>
//                     <Button color="secondary" onClick={toggleModal}>
//                         Cancel
//                     </Button>
//                 </ModalFooter>
//             </Modal>
//         </>
//     );
// }

// export default AllCreateOrder;


























import React, { useState, useEffect } from "react";
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    FormGroup,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter
} from "reactstrap";
import moment from "moment";
import { Link, useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import queryString from "query-string";
import Dataservices from "../../services/requestApi";
import Header from "components/Headers/Header";
import SearchViaDate from "components/Filter/SearchViaDate";
import { Table } from "antd";
import { PlusOutlined } from "@ant-design/icons";

function AllCreateOrder() {
    const [ready, setReady] = useState(false);
    const [search, setSearch] = useState("");
    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [AllOrder, setAllOrder] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState();
    const [totalSales, setTotalSales] = useState({ withTax: 0, withoutTax: 0 });
    const [hasSearched, setHasSearched] = useState(false);
    const [password, setPassword] = useState("");
    const [isPasswordVerified, setIsPasswordVerified] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => setIsModalOpen(!isModalOpen);
    const handlePasswordChange = (e) => setPassword(e.target.value);

    const verifyPassword = () => {
        if (password === "Password@07m") {
            setIsPasswordVerified(true);
            setIsModalOpen(false);
        } else {
            alert("Incorrect password");
        }
    };

    const history = useHistory();

    // ✅ Sirf mount pe default listing
    useEffect(() => {
        GetAllOrder(undefined, undefined, 1, pageSize, "");
    }, []);

    // ✅ Search input ke liye alag useEffect
    useEffect(() => {
        if (search === "" && hasSearched) {
            GetAllOrder(fromDate, toDate, 1, pageSize, "");
            return;
        }
        if (search !== "") {
            const timeout = setTimeout(() => {
                GetAllOrder(fromDate, toDate, 1, pageSize, search);
            }, 500);
            return () => clearTimeout(timeout);
        }
    }, [search]);

    const GetAllOrder = async (from, end, page, size, searchVal) => {
        try {
            setReady(true);
            const res = await Dataservices.getManualOrder(from, end, page, size, searchVal);
            setAllOrder(res.data?.data);
            setTotal(res.data?.total);

            // ✅ Sirf date search hone pe summary set karo
            if (from && end) {
                setHasSearched(true);
                setTotalSales({
                    withTax: res.data?.summary?.totalWithTax || 0,
                    withoutTax: res.data?.summary?.totalWithoutTax || 0,
                });
            } else {
                // ✅ Default listing pe summary reset
                setHasSearched(false);
                setTotalSales({ withTax: 0, withoutTax: 0 });
            }

            setReady(false);
        } catch (e) {
            console.log(e);
            setReady(false);
        }
    };

    const updateProudctOrder = async (id, data) => {
        try {
            await Dataservices.updateProudctOrder(id, queryString.stringify(data));
            GetAllOrder(fromDate, toDate, currentPage, pageSize, search);
        } catch (e) {
            console.log(e);
        }
    };

    const deleteOrder = async (id) => {};

    // ✅ Search click pe pehle reset phir call
    const SearchDate = async () => {
        if (fromDate && toDate) {
            setHasSearched(false);
            setTotalSales({ withTax: 0, withoutTax: 0 });
            setCurrentPage(1);
            GetAllOrder(fromDate, toDate, 1, pageSize, search);
        }
    };

    const csvData = [
        ["Sr No.", "Name", "Phone", "Created on"],
        ...AllOrder?.map((item, idx) => [
            idx + 1,
            item?.distributor?.name,
            item?.distributor?.phone,
            moment(item?.created_at?.split("T")[0]).format("ll"),
        ]),
    ];

    function InvoiceGenerate(id) {
        const CurrentOrder = AllOrder.find((item) => item._id === id);
        history.push({ pathname: "/admin/invoice", state: CurrentOrder });
    }

    function ExportExcel() {}

    const handleTableChange = (page, size) => {
        setCurrentPage(page);
        setPageSize(size);
        GetAllOrder(fromDate, toDate, page, size, search);
    };

    const baseColumns = [
         {
            title: "Order ID",
            dataIndex: "order_id",
            key: "order_id",
        },
        {
            title: "Name",
            dataIndex: "distributor",
            key: "name",
            render: (item) => item?.name,
        },
        {
            title: "Phone",
            dataIndex: "distributor",
            key: "phone",
            render: (item) => item?.phone,
        },
        {
            title: "Created on",
            dataIndex: "created_at",
            key: "created_at",
            render: (date) => moment(date?.split("T")[0]).format("ll"),
        },
        {
            title: "Status",
            dataIndex: "order_id",
            key: "status",
            render: (id, item) => (
                <FormGroup className="w-75 mb-0">
                    <Input
                        id="exampleSelect"
                        name="select"
                        type="select"
                        onChange={(e) =>
                            updateProudctOrder(item._id, { status: e.target.value })
                        }
                        defaultValue={item.status}
                    >
                        <option value="">Update Status</option>
                        <option value="In Process">In Process</option>
                        <option value="Order Dispatched">Order Dispatched</option>
                        <option value="Out for Delivery">Out for Delivery</option>
                        <option value="Order Delivered">Order Delivered</option>
                        <option value="Cancelled">Cancelled</option>
                    </Input>
                </FormGroup>
            ),
        },
        {
            title: "Action",
            dataIndex: "_id",
            key: "action",
            render: (id, item) => (
                <Button
                    onClick={() => InvoiceGenerate(id)}
                    size="sm"
                    color="dark"
                    outline
                    to={`orders-transaction/${item?._id}`}
                    tag={Link}
                >
                    <i className="ni ni-money-coins text-dark mr-2" />
                    View Transactions
                </Button>
            ),
        },
        {
            title: "Invoice",
            dataIndex: "_id",
            key: "invoice",
            render: (id) => (
                <Button onClick={() => InvoiceGenerate(id)} size="sm" color="dark" outline>
                    <span className="ni ni-active-40"></span>
                </Button>
            ),
        },
    ];

    const searchedColumns = [
        {
            title: "Tax Sales",
            dataIndex: "total_amount",
            key: "total_amount",
            render: (amount) => `₹ ${Math.round(amount || 0)}`,
        },
        {
            title: "Without Tax Sales",
            dataIndex: "amount",
            key: "amount",
            render: (amount) => `₹ ${Math.round(amount || 0)}`,
        },
    ];

    const columns = hasSearched ? [...baseColumns, ...searchedColumns] : baseColumns;

    return (
        <>
            <Header show={false} />
            <Container className="mt--7" fluid>
                <Row>
                    <Col className="order-xl-1" xl="12">

                        {/* ✅ Summary Cards - loader khatam hone ke baad real data ke saath */}
                        {hasSearched && !ready && (totalSales.withTax !== 0 || totalSales.withoutTax !== 0) && (
                            <div className="mb-4 mt-4 d-flex" style={{ gap: "20px" }}>
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        padding: "18px 32px",
                                        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                                        borderLeft: "5px solid #2dce89",
                                        minWidth: "220px",
                                    }}
                                >
                                    <p style={{ margin: 0, fontSize: "13px", color: "#888", fontWeight: 500 }}>
                                        Sales With Tax
                                    </p>
                                    <h3 style={{ margin: 0, fontSize: "26px", fontWeight: 700, color: "#2dce89" }}>
                                        ₹{Math.round(totalSales.withTax).toLocaleString("en-IN")}
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        background: "#fff",
                                        borderRadius: "12px",
                                        padding: "18px 32px",
                                        boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
                                        borderLeft: "5px solid #fb6340",
                                        minWidth: "220px",
                                    }}
                                >
                                    <p style={{ margin: 0, fontSize: "13px", color: "#888", fontWeight: 500 }}>
                                        Sales Without Tax
                                    </p>
                                    <h3 style={{ margin: 0, fontSize: "26px", fontWeight: 700, color: "#fb6340" }}>
                                        ₹{Math.round(totalSales.withoutTax).toLocaleString("en-IN")}
                                    </h3>
                                </div>
                            </div>
                        )}

                        <Card className="shadow mt-2">
                            <CardHeader className="bg-white border-0">
                                <Row className="align-items-center">
                                    <Col>
                                        <FormGroup className="mb-0">
                                            <Label for="toDate" className="d-block">&nbsp;</Label>
                                            <Input
                                                id="title"
                                                placeholder="Search by Phone / Name"
                                                type="text"
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <SearchViaDate
                                        fromDate={fromDate}
                                        setFromDate={setFromDate}
                                        toDate={toDate}
                                        setToDate={setToDate}
                                        action={SearchDate}
                                    />
                                    <Col md="3">
                                        <Button className="mt-2" color="primary" onClick={toggleModal}>
                                            Verify Password
                                        </Button>
                                    </Col>
                                    <Button
                                        color="primary"
                                        size="sm"
                                        className="float-right"
                                        to="/admin/create-order"
                                        tag={Link}
                                        disabled={!isPasswordVerified}
                                    >
                                        <PlusOutlined /> Add Order
                                    </Button>
                                </Row>
                            </CardHeader>
                            <CardBody>
                                <CSVLink
                                    className="btn btn-outline-dark btn-sm"
                                    filename="order.csv"
                                    data={csvData}
                                >
                                    Export CSV
                                </CSVLink>
                                <Button onClick={ExportExcel} outline size="sm" color="dark">
                                    Export Excel
                                </Button>

                                <Table
                                    id="AllOrder"
                                    columns={columns}
                                    loading={ready}
                                    dataSource={AllOrder}
                                    pagination={{
                                        current: currentPage,
                                        pageSize: pageSize,
                                        total: total,
                                        showSizeChanger: true,
                                        onChange: (page, size) => handleTableChange(page, size),
                                    }}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            <Modal isOpen={isModalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Verify Password</ModalHeader>
                <ModalBody>
                    <FormGroup>
                        <Input
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={handlePasswordChange}
                            className="form-control-alternative"
                        />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={verifyPassword}>Verify</Button>
                    <Button color="secondary" onClick={toggleModal}>Cancel</Button>
                </ModalFooter>
            </Modal>
        </>
    );
}

export default AllCreateOrder;
